module.exports = __webpack_public_path__ + "images/category_lp/furniture/assessment_achievements/4@2x_07e2618b2fc33ac96083229f314a6680.png";